import React, { useState } from "react";
import { useContext } from "../../../context";
import { ConfirmModal } from "../../../../../../../../../boxes/ConfirmModal/ConfirmModal";
import { useCancelAppointment } from "../../../hooks/useCancelAppointment";

function ModalConfirmCancel() {
  const {
    modals: {
      confirmCancel: { state, isOpen, close },
    },
  } = useContext();

  const cancel = useCancelAppointment({
    isAdditionalProvider: state?.isAdditionalProvider,
  });

  return (
    <>
      {isOpen && (
        <ConfirmModal
          isOpen
          isConfirming={cancel.isLoading}
          onClose={close}
          onCancel={close}
          confirmTitle={state.isAdditionalProvider ? "Yes, remove" : undefined}
          cancelTitle="No, go back"
          onConfirm={() =>
            cancel.initiate({
              charge: state.charge,
              isAdditionalProvider: state.isAdditionalProvider,
            })
          }
        >
          {state.isAdditionalProvider
            ? "Are you sure you want to remove this provider from the appointment?"
            : "Are you sure you want to cancel this appointment?"}
        </ConfirmModal>
      )}
    </>
  );
}

ModalConfirmCancel.useHandler = function () {
  const [state, setState] = useState(null);

  return {
    state,
    isOpen: Boolean(state),
    open: ({ charge, isAdditionalProvider }) => {
      setState({ charge, isAdditionalProvider });
    },
    close: () => {
      setState(null);
    },
  };
};

export { ModalConfirmCancel };
